import './PasswordSetupError.scss';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button } from 'src/modules/common/components/Button';
import { ArrowLeftIcon } from 'src/modules/common/icons/ArrowLeftIcon';

export const PasswordSetupError = (): React.ReactElement => (
  <div className="bp-password-setup-error">
    <h4 className="bp-password-setup-error__title">
      <FormattedMessage id="passwordSetup/error/title"/>
    </h4>

    <p className="bp-password-setup-error__subtitle">
      <FormattedMessage id="passwordSetup/error/subtitle"/>
    </p>

    <div className="bp-password-setup-error__back">
      <Button kind="ghost" as={Link} to="/login" size="md">
        <ArrowLeftIcon/>

        <FormattedMessage id="passwordSetup/goBack"/>
      </Button>
    </div>
  </div>
);
